import * as R from 'ramda'
import {
    call,
     reducer,
    loadStarted,
    loadEnded,
    loadSuccess,
    loadFailure,
    started,
    response,
    failure
 } from '../../helpers/api/meta'
import { errorToBeAdded } from '../../reducers/errorReducer';

import { getCourseFaq,postCourseFaq, patchCourseFaq, deleteFaq } from '../../helpers/api/api';

export const GET_COURSE_FAQ = 'GET_COURSE_FAQ'
export const POST_COURSE_FAQ = 'POST_COURSE_FAQ';
export const EDIT_COURSE_FAQ = 'EDIT_COURSE_FAQ';
export const callGetCourseFaq = (inputs) => {
    const meta = {
        endpoint: (inputs) => getCourseFaq(inputs),
        inputs,
        action: GET_COURSE_FAQ,
        messages: {
            id: 'getCourseFaq',
            failure: 'Could not get course faqs'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    faqs: []
}

const saveCourseFaq = (state, action) => {
    return R.assoc('faqs', action.results, state);
}

const messages = {
    loadFailed: 'Could not load courses faqs.',
}

export default reducer(initialState, GET_COURSE_FAQ, saveCourseFaq, messages.loadFailed)

export const callAddCourseFaq = body => (dispatch) => {
    dispatch(started(POST_COURSE_FAQ));
    return postCourseFaq(body)
      .then((success) => {
        dispatch(response(POST_COURSE_FAQ));
        return success;
      })
      .catch((error) => {
        dispatch(failure(POST_COURSE_FAQ, error));
        throw error;
      });
  };
  
  
  export const callEditCouserFaq = body => (dispatch) => {
    dispatch(started(EDIT_COURSE_FAQ));
    return patchCourseFaq(body)
      .then((success) => {
        dispatch(response(EDIT_COURSE_FAQ));
        return success;
      })
      .catch((error) => {
        dispatch(failure(EDIT_COURSE_FAQ, error));
        throw error;
      });
  };

  export const DELETE_COURSE_FAQ = 'DELETE_COURSE_FAQ';
const errorMsg = 'Unable to delete Course Faq';

export const deleteCouserFaqRequest = (id) => (dispatch) => {
    dispatch(loadStarted(DELETE_COURSE_FAQ));
    return deleteFaq(id)
        .then((response) => {
            dispatch(loadEnded(DELETE_COURSE_FAQ));
            dispatch(loadSuccess(DELETE_COURSE_FAQ));
            return response;
        })
        .catch((error) => {
            dispatch(loadEnded(DELETE_COURSE_FAQ));
            dispatch(loadFailure(DELETE_COURSE_FAQ, error));
            dispatch(errorToBeAdded(error, 'deleteFaq', errorMsg));
        });
};
  

